'use client';

import { Divider, HStack, StackProps, Text, VStack } from '@chakra-ui/react';
import { useAppLayoutContent } from 'context/appLayoutContent';
import { CookieWidget } from 'services/cookieWidget';
import { ZmyleLinks } from 'utils/paths';

import { Link } from '../Link';
import { Button } from '../Button';

interface FooterItem {
  key: string;
  text: string;
  link: string;
}

interface Props extends StackProps {}

export type FooterLinksProps = Props;

export const FooterLinks = (props: Props) => {
  const { appLayoutContent } = useAppLayoutContent();

  const {
    zmyle = '',
    legalInfo = '',
    privacyPolicy = '',
    cookies = '',
  } = appLayoutContent?.footer ?? {};

  const footer: FooterItem[] = [
    {
      key: 'zmyle',
      text: zmyle,
      link: ZmyleLinks.ZMYLE_PAGE,
    },
    {
      key: 'legalInfo',
      text: legalInfo,
      link: ZmyleLinks.LEGAL_INFO,
    },
    {
      key: 'privacyPolicy',
      text: privacyPolicy,
      link: ZmyleLinks.PRIVACY_POLICY,
    },
  ];

  const onClickCookies = () => {
    const cookieWidget = CookieWidget.getInstance();

    cookieWidget.open();
  };

  return (
    <VStack w="full" {...props}>
      <Divider
        display={['none', 'none', 'block']}
        visibility={['hidden', 'hidden', 'visible']}
      />

      <HStack
        fontSize="0.8125rem"
        justify="center"
        align="center"
        w="full"
        fontWeight={400}
        flexWrap="wrap"
      >
        {footer.map(footerItem => {
          const { key, text, link } = footerItem;

          return (
            <HStack key={key}>
              <Link
                href={link}
                target="_blank"
                _hover={{ color: 'dynamic.accent' }}
              >
                <Text>{text}</Text>
              </Link>

              <Text>.</Text>
            </HStack>
          );
        })}

        <Button variant="link" onClick={onClickCookies} color="inherit">
          {cookies}
        </Button>
      </HStack>
    </VStack>
  );
};
